import bytes from 'bytes';
import { useMemo } from 'react';
import { getExtname } from '../services/Helpers'
import { useTranslation } from 'react-i18next';

export function createFileTypeValidator(extnames) {
    if (!extnames) {
        return () => true;
    }
    let match;
    const regex = /[a-z0-9]+/ig;
    const extnamesArray = [];
    while (match = regex.exec(extnames)) {
        extnamesArray.push(match[0].toLowerCase());
    }
    const isValidType = (fileName) => {
        const ext = getExtname(fileName);
        return ext ? extnamesArray.indexOf(ext.toLowerCase()) >= 0 : true;
    };
    isValidType.extnames = extnamesArray.map((ext) => `*.${ext}`).join(', ');
    return isValidType;
}

export default function useFileChecker({ size, extnames } = {}) {
    const { t } = useTranslation();
    return useMemo(() => {
        const isValidType = createFileTypeValidator(extnames);
        const maxFileSize = size ? bytes(size) : 0;
        if (typeof maxFileSize !== 'number') {
            console.error(`Invalid file size format: "${size}"`);
        }
        return function checkFile(file) {
            if (!isValidType(file.name)) {
                let message = t('The selected file has an invalid extension.');
                if (isValidType.extnames) {
                    message += ' ' + t(
                        'Please choose a file with one of the following valid extensions: {{extensions}}.',
                        { extensions: isValidType.extnames }
                    );
                }
                throw new Error(message);
            }
            if (maxFileSize && file.size > maxFileSize) {
                throw new Error(t(
                    'The file size has exceeded the maximum limit of {{size}}',
                    { size: bytes(maxFileSize) }
                ));
            }
        };
    }, [t, size, extnames]);
}
